import * as types from '../types.js';

export default async function(records)
{
	return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; }
			.view td:nth-child(5)	{ text-align: center; }
			.view td:nth-child(6)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(7)	{ text-align: center; }
			.view td:nth-child(8)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(9)	{ text-align: left; max-width: 8rem; }
			.view td:nth-child(10)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(11)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(12)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(13)	{ text-align: left; }
			.view td:nth-child(14)	{ text-align: left; }
			.view td:nth-child(15)	{ text-align: left; }
			.view td:nth-child(16)	{ text-align: right; }
			.view td:nth-child(17)	{ text-align: right; }
			.view td:nth-child(18)	{ text-align: right; }
			.view td:nth-child(19)	{ text-align: left; max-width: 30rem; }
			.view td:nth-child(20)	{ text-align: left; max-width: 24rem; }
			.view td:nth-child(21)	{ text-align: left; }
			.view td:nth-child(22)	{ text-align: center; }
			.view td:nth-child(23)	{ text-align: left; }
			.view th:nth-child(24),
			.view td:nth-child(24),
			.view th:nth-child(25),
			.view td:nth-child(25)	{ text-align: left; max-width: 14rem; }
			.view th:nth-child(26),
			.view td:nth-child(26)	{ text-align: center; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar seleções"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Pedido</th>
					<th data-index="3" data-visible="${this.visible[2]}">Referência</th>
					<th data-index="4" data-visible="${this.visible[3]}">Data Criação</th>
					<th data-index="5" data-visible="${this.visible[4]}">Criado Por</th>
					<th data-index="6" data-visible="${this.visible[5]}">Data Alteração</th>
					<th data-index="7" data-visible="${this.visible[6]}">Alterado Por</th>
					<th data-index="8" data-visible="${this.visible[7]}">Cliente</th>
					<th data-index="30" data-visible="${this.visible[8]}">Rota</th>
					<th data-index="9" data-visible="${this.visible[9]}">Transportador</th>
					<th data-index="10" data-visible="${this.visible[10]}">Programa</th>
					<th data-index="11" data-visible="${this.visible[11]}">Atendimento</th>
					<th data-index="12" data-visible="${this.visible[12]}">Pagamento</th>
					<th data-index="13" data-visible="${this.visible[13]}">Condição</th>
					<th data-index="14" data-visible="${this.visible[14]}">Tipo Frete</th>
					<th data-index="15" data-visible="${this.visible[15]}">Valor Frete</th>
					<th data-index="16" data-visible="${this.visible[16]}">% Desconto</th>
					<th data-index="17" data-visible="${this.visible[17]}">Valor</th>
					<th data-index="18" data-visible="${this.visible[18]}">Observações</th>
					<th data-index="19" data-visible="${this.visible[19]}">Obs. livro eletrônico</th>
					<th data-index="20" data-visible="${this.visible[20]}">Devolução</th>
				<th data-index="21" data-visible="${this.visible[21]}">Status</th>
				<th data-index="25" data-visible="${this.visible[22]}">Prev. Entrega</th>
				<th data-index="23" data-visible="${this.visible[23]}">SKU (itens)</th>
				<th data-index="24" data-visible="${this.visible[24]}">Produto (itens)</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async record => 
				`<tr data-id='${JSON.stringify([record.company_id, record.id])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([record.company_id, record.id]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick') || ''}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.reference || ''}</td>
					<td data-visible='${this.visible[3]}'>${this.format(types.datetime(), record.created_on)}</td>
					<td data-visible='${this.visible[4]}'>${await this.key('users', record.created_by)}</td>
					<td data-visible='${this.visible[5]}'>${this.format(types.datetime(), record.updated_on) || ''}</td>
					<td data-visible='${this.visible[6]}'>${await this.key('users', record.updated_by) || ''}</td>
					<td data-visible='${this.visible[7]}'>${await this.key('customers', [record.company_id, record.customer_id], 'nick') || ''}</td>
					<td data-visible='${this.visible[8]}' title="${record.route_name || ''}">${record.route_code || ''}</td>
					<td data-visible='${this.visible[9]}'>${await this.key('carriers', [record.company_id, record.carrier_id], 'nick') || ''}</td>
					<td data-visible='${this.visible[10]}'>${await this.key('programs', record.program_id ? [record.company_id, record.program_id] : null, 'name') || ''}</td>
					<td data-visible='${this.visible[11]}'>${this.option(types.opt_service_channel(), record.service_channel)}</td>
					<td data-visible='${this.visible[12]}'>${this.option(types.opt_payment_method(), record.payment_method)}</td>
					<td data-visible='${this.visible[13]}'>${await this.key('payment_terms', [record.company_id, record.payment_term_id]) || ''}</td>
					<td data-visible='${this.visible[14]}'>${this.option(types.opt_freight_type(), record.freight_type) || ''}</td>
					<td data-visible='${this.visible[15]}'>${record.freight_value ? this.format(types.number(2), record.freight_value) : ''}</td>
					<td data-visible='${this.visible[16]}'>${record.discount != null ? this.format(types.number(2), record.discount) : ''}</td>
					<td data-visible='${this.visible[17]}'>${this.format(types.number(2), record.value)}</td>
					<td data-visible='${this.visible[18]}'>${record.notes || ''}</td>
					<td data-visible='${this.visible[19]}'>${record.book_observation || ''}</td>
					<td data-visible='${this.visible[20]}'>${this.option(types.opt_bool(), record.is_return)}</td>
				<td data-visible='${this.visible[21]}'>${this.option(types.opt_output_order_status(), record.status) || ''}</td>
				<td data-visible='${this.visible[22]}'>${this.format(types.date(), record.expected_delivery_date) || ''}</td>
				<td data-visible='${this.visible[23]}'>${record.lines_sku_summary || ''}</td>
				<td data-visible='${this.visible[24]}'>${record.lines_product_summary || ''}</td>
				</tr>`
				))).join('') +
			`
			</tbody>
		</table>
	`;
};

